import React from 'react'
import styled, {withTheme} from 'styled-components'

const CloseContainer = styled.div`
  width: 0.83rem;
  height: 0.61rem;
  margin-right: 0.39rem;
`

const Close = ({theme}) => (
  <CloseContainer>
    <svg width="0.61rem" height="0.61rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 13">
      <g fill="none" fillRule="evenodd" stroke={theme.colors.neutralDark} strokeLinecap="round" strokeWidth="1.25">
        <path d="M1 1l10.968 10.968M11.968 1L1 11.968"/>
      </g>
    </svg>
  </CloseContainer>
)

export default withTheme(Close)


// WEBPACK FOOTER //
// ./assets/completion/images/Close.js